import React from "react";
import type { IPaymentGatewayChoice } from "@/src/shared/features/payment/types";

/** The app's "Save payment method" box, shown only while plain bKash is picked. */
const SaveBkashCheckbox: React.FC<{
  choice: IPaymentGatewayChoice;
  className?: string;
}> = ({ choice, className = "" }) =>
  choice.gateway === "bkash" ? (
    <button
      type="button"
      role="checkbox"
      aria-checked={choice.saveBkash}
      onClick={choice.toggleSaveBkash}
      className={`flex items-center gap-2.5 text-14 text-ink-dark ${className}`}
    >
      {choice.saveBkash ? (
        <img
          src="/icons/confirm-pay/payment_save_checked.svg"
          alt=""
          className="h-5 w-5"
        />
      ) : (
        <span className="h-5 w-5 rounded border-[1.5px] border-[#222222]" />
      )}
      Save payment method
    </button>
  ) : null;

export default SaveBkashCheckbox;
